export const getFormattedAverageRating = (avgRating: string | number | undefined | null): string => {
  if (avgRating && Number.isFinite(Number(avgRating))) {
    const numberedAvgRating = Number(avgRating)
    if (numberedAvgRating > 0 && numberedAvgRating <= 5) {
      return Number(avgRating).toFixed(1)
    }
  }
  return ''
}
